export default __webpack_public_path__ + "/images/empty-table.svg";